export default {
    SET_SELECTION: (state, selection) => {
        state.filters.sendTo = selection
    },
    SET_COUNT: (state, count) => {
        state.count = count
    },
    SET_CLIENTS: (state, clients) => {
        state.clients = clients
    },
    CLEAR_NOTIFICATION: (state) => {
        state.notification = {
            title: '',
            body: '',
            image: ''
        }
    },
    SET_PHONES: (state, phones) => {
        state.filters.phones = phones
    },
    SET_NORMALIZE_PHONES: (state, normalizePhones) => {
        state.normalizePhones = normalizePhones
    },
    SET_RESULT: (state, result) => {
        state.result = result
    },
    SET_LOAD(state, isLoaded) {
        state.isLoaded = isLoaded
    }
}
